module.exports = __webpack_public_path__ + "img/banner@2x.8f6645e7.jpg";